import { gql } from '@apollo/client';

export const TEST_SESSION_LIST = gql`
  query TestSessionList($limit: Int, $status: [TestSessionStatusEnum!], $company: String, $project: String) {
      testSessionList(limit: $limit, status: $status, company: $company, project: $project) {
          id
          createdAt
          status
          companyName
          fullName
          tester {
              id
              project {
                  id
                  name
              }
          }
      }
  }
`;
